import { uri } from "../constants";
import axios from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export async  function registerUser(data) {
    const response = await axios.post(`${uri}/auth/register`, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export async function createBulkUsers(data) {
    const response = await axios.post(`${uri}/users/bulk`, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}
export async function getUserAnalytics(userId){
    const response = await axios.get(`${uri}/users/${userId}/analytics`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data.user;
}
export async function loginUser(token) {
    const response = await axios.post(`${uri}/auth/login`, {token: token},{
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
}
export async function getUsersWithRel() {
    const response = await axios.get(`${uri}/users/admin/all`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data.users;
}
export async function getUser(userId) {
    const response = await axios.get(`${uri}/users/${userId}`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data.user;
}
export async function updateUser(userId, data) {
    const response = await axios.put(`${uri}/users/${userId}`, data,{
        headers: {
            'Content-Type': 'application/json',
        }
    })
    return response.data.user;
}
export async function getAllUsers() {
    const response = await axios.get(`${uri}/users`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data.users;
}
export async function createAdmin(data) {
    const response = await axios.post(`${uri}/admin`, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
}
export async function updateAdmin(userId, data) {
    const response = await axios.put(`${uri}/admin/${userId}`, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
}
export async function removeAdmin(userId) {
    const response = await axios.delete(`${uri}/admin/${userId}`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
}

export const useRemoveAdmin = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (userId) => removeAdmin(userId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            onSuccess();
        },
        onError: (error) => {
            onError(error);
        },
    });
};


export const useUpdateAdmin = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ userId, data }) => updateAdmin(userId, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            onSuccess();
        },
        onError: (error) => {
            onError(error);
        },
    });
};

export const useCreateAdmin = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => createAdmin(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            onSuccess();
        },
        onError: (error) => {
            onError(error);
        },
    });
}